module.exports = __webpack_public_path__ + "static/media/linkedin.11a5ec5f.svg";